export default __webpack_public_path__ + "static/media/anjan_logo.05f6d725.png";